import { RcFile } from 'antd/lib/upload';
import { UploadArchiveResult } from '../../archive/Archive/Archive.types';
import { WorkOrderComplementTankLevel } from '../WorkOrdersComplements/WorkOrdersComplements.types';
import { ContactType } from '../../_shared/ContactType';
import {
  AdministrativeReportCode,
  DefaultName,
  ReportTypes,
} from '../../reports/company/Company.types';
import { WorkOrderVehicle } from '../WorkOrders/WorkOrders.types';
import { Color } from '../../people/Colors/Colors.types';
import { Fuel } from '../../people/Fuels/Fuels.types';
import { Model } from '../../people/BrandsModelsVersions/BrandsModelsVersions.types';
import { VehicleType } from '../../people/CustomerVehicles/CustomerVehicles.types';
import { WorkOrderObservationVisibility } from '../WorkOrdersObservations/WorkOrdersObservations.types';

export interface WorkOrderImagesCreateRequest {
  diagnosticId?: number;
  workOrderComplementId?: number;
  filePath: string[];
}

export interface WorkOrderImagesListRequest {
  workOrderComplementId?: number;
  diagnosticId?: number;
}

export interface WorkOrderChecklistImage {
  id: number;
  filePath: string;
}

export interface WorkOrderChecklistImageResponse {
  listChecklistImage: WorkOrderChecklistImage[];
}

export interface WorkOrderChecklistImagesFormValues {
  images: (RcFile & { response: UploadArchiveResult })[];
}

export interface WorkOrderChecklistRequestServiceListRequest {
  workOrderComplementId?: number;
  diagnosticId?: number;
}

export interface WorkOrderChecklistRequestService {
  id: number;
  checklistId: number;
  requestedService: string;
  comments: string;
}

export interface WorkOrderChecklistRequestServiceCreateRequest {
  diagnosticId?: number;
  workOrderComplementId?: number;
  requestedService: string;
  comments: string;
}

export interface WorkOrderChecklistRequestServiceUpdateRequest {
  id: number;
  requestedService: string;
  comments: string;
}

export interface WorkOrderChecklistRequestServiceFormValues {
  requestedServiceSelected?: string;
  requestedService: string;
  comments: string;
}

export type WorkOrderChecklistQuickAnswer = {
  description: string;
  response: boolean;
  comment?: string;
};

export interface WorkOrderChecklistQuickCreate {
  workOrderComplementId?: number;
  diagnosticId?: number;
  answer: WorkOrderChecklistQuickAnswer[];
}

export interface WorkOrderChecklistQuick {
  id: number;
  checklistId: number;
  description: string;
  response: boolean;
  comment?: string;
}

export interface WorkOrderChecklistQuickListRequest {
  workOrderComplementId?: number;
  diagnosticId?: number;
}

export interface WorkOrderChecklistAccessory {
  id: number;
  checkListId: number;
  accessoryId: number;
  comment: string;
}

export interface WorkOrderChecklistAccessoryListRequest {
  workOrderComplementId?: number;
  diagnosticId?: number;
}

export interface WorkOrderChecklistAccessoryItem {
  accessoryId: number;
  comment?: string;
}

export interface WorkOrderChecklistAccessoryCreate {
  diagnosticId?: number;
  workOrderComplementId?: number;
  accessories: WorkOrderChecklistAccessoryItem[];
}

export interface WorkOrderChecklistComplementItemsListRequest {
  workOrderComplementId?: number;
  diagnosticId?: number;
}

export interface WorkOrderChecklistComplementItem {
  id: number;
  checklistId: number;
  description: string;
  response: ChecklistComplementItemResponse;
  comment: string;
}

export enum ChecklistComplementItemResponse {
  Ok = 'domain.enums.checklist_complementary_response.ok',
  NotOk = 'domain.enums.checklist_complementary_response.not_ok',
  Warning = 'domain.enums.checklist_complementary_response.warning',
}

export interface WorkOrderChecklistComplementItemCreate {
  diagnosticId?: number;
  workOrderComplementId?: number;
  answers: ChecklistComplementItemFieldsRequest[];
}

export type ChecklistComplementItemFields = {
  description: string;
  response: [ChecklistComplementItemResponse];
  comment: string;
};

export type ChecklistComplementItemFieldsRequest = {
  description: string;
  response: ChecklistComplementItemResponse;
  comment: string;
};

export interface ChecklistComplementItemFormValues {
  'items-ground': ChecklistComplementItemFields[];
  'items-lift': ChecklistComplementItemFields[];
  'items-test-run': ChecklistComplementItemFields[];
}

export interface ChecklistComplementItemRequest {
  'items-ground': ChecklistComplementItemFieldsRequest[];
  'items-lift': ChecklistComplementItemFieldsRequest[];
  'items-test-run': ChecklistComplementItemFieldsRequest[];
}

export interface WorkOrderChecklistDamage {
  id: number;
  checkListId: number;
  x: number;
  y: number;
  damage: string;
}
export interface WorkOrderChecklistDamageListRequest {
  workOrderComplementId?: number;
  diagnosticId?: number;
}

export interface WorkOrderChecklistDamageAnswer {
  id?: number;
  position: {
    x: number;
    y: number;
  };
  damage: string;
}

export interface WorkOrderChecklistDamageCreate {
  diagnosticId?: number;
  workOrderComplementId?: number;
  answers: WorkOrderChecklistDamageAnswer[];
}

export interface WorkorderChecklistFutureServiceItem {
  date: string;
  description: string;
}

export interface WorkOrderChecklistFutureServiceCreate {
  diagnosticId?: number;
  workOrderComplementId?: number;
  futureService: WorkorderChecklistFutureServiceItem;
}

export interface WorkOrderChecklistFutureServiceEdit {
  id: number;
  date: string;
  description: string;
}

export interface WorkOrderChecklistFutureService {
  id: number;
  checkListId: number;
  date: string;
  description: string;
}

export interface WorkOrderChecklistFutureServiceListRequest {
  workOrderComplementId?: number;
  diagnosticId?: number;
}

export interface WorkOrderChecklistFutureServiceToWorkorder {
  workOrderComplementId: number;
  ids: number[];
}

export interface WorkOrderChecklistFutureServiceImportExcludedServices {
  date: string;
  ids: number[];
}

export interface ReportChecklistRequest {
  workOrderComplementId?: number;
  diagnosticId?: number;
  companyId?: number;
}

export interface ReportChecklistDamageData {
  id: number;
  x: number;
  y: number;
  damage: string;
}

export interface ReportChecklistAccessoriesData {
  accessoryId: number;
  comment: string;
  description: string;
  selected: boolean;
}

export interface ReportChecklistContact {
  description: string;
  contactType: ContactType;
  value: string;
}

export interface ReportChecklistCompany {
  id: number;
  name: string;
  nickName: string;
  cnpj: string;
  filePath: string;
  email: string;
  bosch: boolean;
}

export interface ReportChecklistData {
  worKOrder?: {
    number: string;
    tankLevel: WorkOrderComplementTankLevel;
    entryDate: string;
    closingDate: string;
  };
  checklistObservations?: {
    id: number;
    createdAt: string;
    employeeName: string;
    observation: string;
    visibility: WorkOrderObservationVisibility;
  }[];
  customer?: {
    name: string;
    contacts?: ReportChecklistContact[];
    documentNumber?: string;
    foreignDocument?: string;
    addressResponse: {
      zipCode: string;
      district: string;
      street: string;
      complement: string;
      number: string;
      city: string;
    };
  };
  company?: ReportChecklistCompany;
  vehicle?: {
    licensePlate: string;
    chassi: string;
    km: number;
    model: string;
    yearFabrication: number;
    yearModel: number;
    type?: VehicleType;
  };
  accessories?: ReportChecklistAccessoriesData[];
  complementaryItems?: {
    id: number;
    checklistId: number;
    description: string;
    response: string;
    comment: string;
  }[];
  damages?: ReportChecklistDamageData[];
  futureServices?: {
    id: number;
    date: string;
    description: string;
  }[];
  listChecklistImages?: {
    id: number;
    filePath: string;
  }[];
  checklistQuicks?: {
    id: number;
    description: string;
    response: boolean;
  }[];
  checklistRequestedServices?: {
    id: number;
    requestedService: string;
    comments: string;
  }[];
}

export interface ReportChecklistPublicData {
  checklistReportResponse: ReportChecklistData;
  companyReportConfig: {
    administrativeReportCode: AdministrativeReportCode;
    administrativeReportFormat: ReportTypes;
    companyId: number;
    companyNaming: DefaultName;
    id: number;
    matrixId: number;
    quotationMapReportFormat: ReportTypes;
    showObservation: boolean;
    workshopReportFormat: ReportTypes;
  };
  signature: {
    signature: string;
  };
}

export interface ChecklistVehicle extends WorkOrderVehicle {
  customerId: number;
}

export interface CustomerVehicleCombined {
  brandName: string;
  customerId: number;
  id: number;
  licensePlate: string;
  modelName: string;
  yearFabrication: number;
  yearModel: number;
  active?: boolean;
  chassi?: string;
  color?: Color;
  customerName?: string;
  fuel?: Fuel;
  km?: number;
  model?: Model;
  fleet?: string;
  renavam?: string;
  type?: VehicleType;
  accessories?: {
    id: number;
    description: string;
  }[];
}

export interface ChecklistSignatureWithTokenRequest {
  signature: string;
  token?: string;
}

export interface ChecklistImageMultipleRemoveRequest {
  imageIds: number[];
}

export interface ChecklistObservationsListRequest {
  workOrderComplementId?: number;
  diagnosticId?: number;
  visibility?: WorkOrderObservationVisibility;
}

export interface ChecklistObservationListResponse {
  id: number;
  employeeId: number;
  employeeName: string;
  observation: string;
  createdAt: string;
  visibility: WorkOrderObservationVisibility;
  checklistId: number;
}

export interface ChecklistObservationRequest {
  observationId?: number;
  observation: string;
  workOrderComplementId?: number;
  diagnosticId?: number;
  visibility: WorkOrderObservationVisibility;
}
